"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HDStreamingService = void 0;
const operators_1 = require("rxjs/operators");
const __1 = require("..");
const http_1 = require("@angular/common/http");
class HDStreamingService extends __1.RestService {
    constructor() {
        super(...arguments);
        this.hdStreamingOffersUrl = '/rest-api/catalog/v1/offers/';
        this.hdStreamingActivePassUrl = '/rest-api/account/sub/v1/offers/';
        this.hdStreamingAddOfferUrl = this.hdStreamingActivePassUrl;
        this.hdStreamingRemoveOfferUrl = this.hdStreamingActivePassUrl;
    }
    getAllStreamingOffers() {
        return this.get(this.hdStreamingOffersUrl).pipe(operators_1.map((data) => data));
    }
    getActiveStreamingOffer(subscriptionId) {
        return this.get(this.hdStreamingActivePassUrl + subscriptionId).pipe(operators_1.map((data) => data));
    }
    addHdStreamingOffer(subscriptionId, offerName) {
        const inputArgs = new http_1.HttpParams().set('subscriptionId', subscriptionId).set('offerName', offerName);
        return this.post(this.hdStreamingAddOfferUrl, inputArgs).pipe(operators_1.map((data) => data));
    }
    removeHdStreamingOffer(subscriptionId, offerName) {
        return this.delete(this.hdStreamingRemoveOfferUrl + subscriptionId + '/' + offerName).pipe(operators_1.map((data) => data));
    }
}
exports.HDStreamingService = HDStreamingService;
//# sourceMappingURL=streaming.service.js.map